import { ISurveyTargetLine } from "./survey.types";

export class SurveyTargetLine implements ISurveyTargetLine {
  lineTurnUid: string;
  lineTurnName: string;
  turnFullName: string;
  lineTypeCode: string;
  lineTypeName: string;

  constructor(data: ISurveyTargetLine) {
    this.lineTurnUid = data.lineTurnUid;
    this.lineTurnName = data.lineTurnName;
    this.turnFullName = data.turnFullName;
    this.lineTypeCode = data.lineTypeCode;
    this.lineTypeName = data.lineTypeName;
  }
}
